/** PHKL Custom -s
 * Only for phkl GA
 * */
export type PHKLGAEventName = "ui_click" | "ui_screen_visit";

export type PHKLGAEventType = "Click" | "Screen";

export type PHKLGAModule = "CandidateWebApp";

export type PHKLGAFeature = string;

export type PHKLGAJourney = string;

export type PHKLGAStage = string;

export type PHKLGAScreenName = string;

export type PHKLGAScreenId = string;

export enum PHKLOBJECT_TYPE {
  BUTTON = "BUTTON",
  HYPERLINK = "HYPERLINK",
}

export const PHKLGAEventSource = "PRUForceCW_hk_web";
export const PHKLCandidateGAModule = "CandidateWebApp";
export const PHKLCandidateGAFeature = "Candidate";
export const PHKCandidateLanding = "landing";
export const PHKCandidateLandingScreenName = "CandidateWebAppLandingPage";

export enum ONBOARDING_TRAINING_OBJECT_NAME {
  EXAM_REGISTRATION = "exam_registration",
  STUDY_MATERIALS = "study_materials",
  COURSE_ENROLMENT = "course_enrolment",
  MOCK_EXAM = "mock_exam",
  PRACTICE_QUESTIONS = "practice_questions",
  ONBOARDING_TRAINING = "onboarding_training",
}

// PHKL Custom -e
